import { render } from "./Alert.vue?vue&type=template&id=3c3e9e61&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=3c3e9e61&scoped=true&lang=css"

import exportComponent from "../../../Bocco/Rental/WebApp/Bocco/Rental/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3e9e61"]])

export default __exports__